"use strict";

const FAVORITE_BUTTON_SELECTOR = "[data-product-favorite]";
const AJAX_ACTION = "favorites_toggle_action";

function setButtonState(button, isActive) {
    button.classList.toggle("is-active", isActive);
    button.setAttribute("aria-pressed", String(isActive));
}

async function toggleFavorite(button) {
    if (!window.WPURLS?.ajaxUrl || button.dataset.loading === "1") {
        return;
    }

    const productId = button.getAttribute("data-product-id");

    if (!productId) {
        return;
    }

    button.dataset.loading = "1";

    const data = new FormData();
    data.append("action", AJAX_ACTION);
    data.append("nonce", window.WPURLS.nonce);
    data.append("product", productId);

    try {
        const response = await fetch(window.WPURLS.ajaxUrl, {
            method: "POST",
            credentials: "same-origin",
            body: data,
        });

        const payload = await response.json();

        if (payload && payload.success) {
            setButtonState(button, Boolean(payload.data?.active));
        }
    } catch (error) {
        // Silenzioso: lo stato del pulsante resta invariato.
    } finally {
        delete button.dataset.loading;
    }
}

// Event delegation: sopravvive ai re-render AJAX della griglia prodotti.
document.addEventListener("click", (event) => {
    const button = event.target.closest(FAVORITE_BUTTON_SELECTOR);

    if (!button) {
        return;
    }

    event.preventDefault();
    toggleFavorite(button);
});
